export const dlPush = (obj) => {
  if (process.browser) {
    window.dataLayer.push(obj)
  }
}